var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandAppleStyleBrand = function SvgBrandAppleStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandAppleStyleBrand__clip0_118_367275)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.195 17.858c-.558 1.2-.824 1.736-1.543 2.797-1 1.48-2.411 3.325-4.16 3.34-1.553.015-1.952-.982-4.062-.97-2.109.012-2.548.99-4.102.975-1.748-.015-3.086-1.68-4.085-3.163-2.8-4.143-3.092-9.003-1.366-11.588C4.104 7.411 6.04 6.338 7.861 6.338c1.851 0 3.017.986 4.55.986 1.485 0 2.39-.988 4.535-.988 1.619 0 3.334.856 4.558 2.339-4.007 2.134-3.356 7.694.691 9.183m-6.65-14.114c.78-.972 1.369-2.342 1.155-3.744-1.272.084-2.76.87-3.626 1.896-.788.93-1.44 2.31-1.188 3.653 1.388.041 2.825-.766 3.66-1.805"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandAppleStyleBrand__clip0_118_367275"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandAppleStyleBrand);
export { ForwardRef as ReactComponent };